import { useAuthContext } from 'components/Auth/AuthContextProvider'

import useApiSWR, { ApiSWRResponse } from './useApiSWR'

interface AccountBasicInfoResponse {
  AppUserID: number
  RoleID: number
  FirstName?: string
  LastName?: string
  ImageURL?: string
  Email?: string
  UserName?: string
}

const useAccountBasicInfo = (
  enabled = true
): ApiSWRResponse<AccountBasicInfoResponse> => {
  const { user } = useAuthContext()

  const params = { userID: user?.appUserId ?? null }

  const response = useApiSWR<AccountBasicInfoResponse>({
    method: 'GET',
    endpoint: '/api/Account/GetAccountBasicInfo',
    params,
    enabled,
    config: {
      revalidateOnFocus: false,
      revalidateIfStale: false,
    },
  })

  if (process.env.NEXT_PUBLIC_USE_SSO !== 'true') {
    return { ...response, data: mockData, error: null }
  }

  return response
}

const mockData = {
  AppUserID: -1,
  RoleID: -1,
  FirstName: 'Test',
  LastName: 'User',
  ImageURL: 'https://vhap.usc.edu/vhap.iwitness.appdata/images/user-circle.svg',
  Email: '<email>',
  UserName: '<username>',
}

export default useAccountBasicInfo
